export default "__VITE_ASSET__D4Mp$zyK__"